import { React, useCallback, useEffect, useState } from "react";
import Slider from "react-slick";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import { FreeMode, Pagination, Navigation } from "swiper";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/bundle";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));


export function Layout1(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };
  var settings = {
    slidesToShow: 1,
    arrows: false,
    dots: false,
    swipeToSlide: true,
    speed: 200,
    infinite: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {window.innerWidth > 768 ?
        <>
          <section className="mb-0 dD-block">
            <div className="temp26">
              {/* {showShimmer ? (
                <div className="line" style={{ margin: "0px 30px" }} />
              ) : ( */}
              <>
                <div className="head-layout">
                  <h3>
                    {props.title.display_title}
                    <span className="red">{props.title.display_title_sufix}</span>
                  </h3>
                </div>
              </>
              {/* )} */}

              <div className="temp26-area">
                <Swiper
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  spaceBetween={16}
                  slidesPerGroup={5}
                  freeMode={true}
                  loop={false}
                  centeredSlides={false}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    850: {
                      slidesPerView: 3,
                    },
                  }}
                  modules={[Navigation, FreeMode, Pagination]}
                  className="temp26-slider"
                >
                  <div className="side-overlay-L dD-block"></div>
                  <button
                    className="slick-prev slick-arrow"
                    type="button"
                    aria-label="Previous"
                  />
                  {props.Layout1.map((data, index) => {
                    var Counter = index + 1;
                    var Genre = data.genres.split(",");
                    Genre = Genre[0];
                    var keyword = data.keywords.split(",")[0];
                    if (data.content_publish_on == "Today") {
                      var vali = "Today";
                    } else if (data.content_publish_on == "Tomorrow") {
                      var vali = "Tomorrow";
                    } else if (data.content_publish_on == "Coming Soon") {
                      var vali = "Coming Soon";
                    } else {
                      var vali = "Coming Soon";
                    }
                    return (
                      <SwiperSlide key={"temp26-item_" + data.ID}>
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" style={{ height: "200px" }} />
                        ) : ( */}
                        <>
                          <div className="temp26-sliderItem">
                            {data.content_publish_on == "Coming Soon" ? (
                              <div className="temp26-item">
                                <div className="temp26-itemColor">
                                  <img
                                    src={data.thumbnail_image1.medium}
                                    alt="DocuBay"
                                  />
                                </div>
                                <div className="daily-title">
                                  <div className="daily-text">{vali}</div>
                                  <div className="daily-btn">{keyword}</div>
                                </div>
                              </div>
                            ) : (
                              <Link to={"/" + data.slug}>
                                <div className="temp26-item">
                                  <div className="temp26-itemColor">
                                    <img
                                      src={data.thumbnail_image1.medium}
                                      alt="DocuBay"
                                    />
                                  </div>
                                  <div className="daily-title">
                                    <div className="daily-text">{vali}</div>
                                    <div className="daily-btn">{keyword}</div>
                                  </div>
                                </div>
                              </Link>
                            )}
                          </div>
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                  <SwiperSlide></SwiperSlide>
                  <div className="side-overlay-R dD-block"></div>
                  <button
                    className="slick-next slick-arrow"
                    type="button"
                    aria-label="Next"
                  />
                </Swiper>
              </div>
            </div>
          </section>
        </>
        :
        <>
          <section className="mb-0 dD-none">
            <div className="temp26">
              {/* {showShimmer ? (
            <div className="line linehead" />
          ) : (
            <>    </>
            )} */}
              <div className="head">
                <h3>
                  {props.title.display_title}
                  <span className="red">{props.title.display_title_sufix}</span>
                </h3>
              </div>

              <div className="temp26-area">
                <Slider {...settings} className="temp26-slider">
                  {props.Layout1.map((data, index) => {
                    var Counter = index + 1;
                    var Genre = data.genres.split(",");
                    Genre = Genre[0];
                    var keyword = data.keywords.split(",")[0];
                    if (data.content_publish_on == "Today") {
                      var vali = "Today";
                    } else if (data.content_publish_on == "Tomorrow") {
                      var vali = "Tomorrow";
                    } else if (data.content_publish_on == "Coming Soon") {
                      var vali = "Coming Soon";
                    } else {
                      var vali = "Coming Soon";
                    }
                    return (
                      <div className="temp26-sliderItem" key={data.ID}>
                        {/* {showShimmer ? (
                      <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" style={{height:"300px"}}/>
                    ) : (
                      <>   </>
                      )} */}
                        {data.content_publish_on == "Coming Soon" ? (
                          <div className="temp26-item">
                            <div className="temp26-itemColor">
                              <img
                                src={data.thumbnail_image2.small}
                                alt="DocuBay"
                              />
                              <div className="temp26-swipeBtn">
                                <img src={SVGIcon["swipe-btn.svg"]} />
                              </div>
                            </div>
                            <div className="daily-title">
                              <div className="daily-text">{vali}</div>
                              <div className="daily-btn">{keyword}</div>
                            </div>
                          </div>
                        ) : (
                          <div
                            onClick={() => {
                              showdetailspop(data);
                            }}
                          >
                            <div className="temp26-item">
                              <div className="temp26-itemColor">
                                <img
                                  src={data.thumbnail_image2.medium}
                                  alt="DocuBay"
                                />
                                <div className="temp26-swipeBtn">
                                  <img src={SVGIcon["swipe-btn.svg"]} />
                                </div>
                              </div>
                              <div className="daily-title">
                                <div className="daily-text">{vali}</div>
                                <div className="daily-btn">{keyword}</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          </section>
        </>
      }


      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout1;
